export default __webpack_public_path__ + "static/media/icon-phone.2455cf75.svg";